import { OrderSearchCriteria } from './OrderSearchCriteria';

export class OrderSearchExportCriteria {
  query?: OrderSearchCriteria;
  visibleColumns?: (string | undefined)[];

  constructor(opts?: Partial<OrderSearchExportCriteria>) {
    if (opts?.query != null) {
      this.query = opts.query;
    }
    if (opts?.visibleColumns != null) {
      this.visibleColumns = opts.visibleColumns.map((val) => val);
    }
  }
}
